import type { EventHint, ErrorEvent } from "@sentry/types";

import { batBeacon } from "../filters/batBeacon/batBeacon";
import { chunkLoadError } from "../filters/chunkLoadError/chunkLoadError";
import { objectMatchingId } from "../filters/objectMatchingId/objectMatchingId";
import { resizeObserverLoop } from "../filters/resizeObserverLoop/resizeObserverLoop";
import { thirdPartyDomains } from "../filters/thirdPartyDomains/thirdPartyDomains";
import { errorsTurnedOffFilter } from "../filters/turnErrorsOff/turnErrorsOff";
import { webkitMessageHandlers } from "../filters/webkitMessageHandlers/webkitMessageHandlers";

const filters = {
  batBeacon,
  chunkLoadError,
  thirdPartyDomains,
  objectMatchingId,
  resizeObserverLoop,
  errorsTurnedOffFilter,
  webkitMessageHandlers,
};

export const beforeSend = (event: ErrorEvent, hint: EventHint) => {
  for (const filter of Object.values(filters)) {
    const result = filter(event, hint);
    if (!result) return null;
  }

  return event;
};
